import React, { useState, useEffect } from "react";
import styles from "./NameAndDescription.module.sass";

// Screens
import PartnerInformations from "./PartnerInformations";
import AddressInformations from "./AddressInformations";
import AdminInformations from "./AdminInformations";
import ContactInformations from "./ContactInformations";

// Services
import { updatePartner } from "../../../services/partner.service";
import { showSuccess, showError } from "../../../services/toast.service";

const NameAndDescription = ({ partner, onPartnerUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [partnerData, setPartnerData] = useState(partner || {});
  const [hasChanges, setHasChanges] = useState(false);

  // Mettre à jour les données locales quand le partenaire change
  useEffect(() => {
    if (partner) {
      setPartnerData(partner);
      setHasChanges(false);
    }
  }, [partner]);

  const handlePartnerChange = (e) => {
    const { name, value } = e.target;
    setPartnerData((prev) => ({ ...prev, [name]: value }));
    setHasChanges(true);
  };

  const handleSwitchChange = (name, value) => {
    setPartnerData((prev) => ({ ...prev, [name]: value }));
    setHasChanges(true);
  };

  const handleDropdownChange = (name, value) => {
    // Extraire uniquement la valeur du dropdown si c'est un objet avec une propriété value
    let finalValue = value && typeof value === 'object' && value.value !== undefined ? value.value : value;
    setPartnerData((prev) => ({ ...prev, [name]: finalValue }));
    setHasChanges(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!hasChanges) {
      showSuccess("Aucune modification à sauvegarder");
      return;
    }
    
    setLoading(true);
    setError(null);
    
    try {
      const updatedPartner = await updatePartner(partner.id, partnerData);
      showSuccess("Partenaire mis à jour avec succès!");
      onPartnerUpdate(updatedPartner);
      setHasChanges(false);
    } catch (err) {
      const errorMessage =
        "Impossible de mettre à jour le partenaire: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {error && <div className={styles.error}>{error}</div>}
      <form onSubmit={handleSubmit}>
        <PartnerInformations
          partner={partnerData}
          onPartnerChange={handlePartnerChange}
          onDropdownChange={handleDropdownChange}
          onSwitchChange={handleSwitchChange}
        />
        <AddressInformations
          partner={partnerData}
          onPartnerChange={handlePartnerChange}
        />
        <AdminInformations
          partner={partnerData}
          onPartnerChange={handlePartnerChange}
        />
        <ContactInformations
          partner={partnerData}
          onPartnerChange={handlePartnerChange}
          onDropdownChange={handleDropdownChange}
          loading={loading}
          hasChanges={hasChanges}
        />
      </form>
    </>
  );
};

export default NameAndDescription;
